import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Add parameters to srcset to support serving images through imgix.com domain.
 * Some default values are based on imgix.com documentation
 *
 * __Usage :__
 *   <img src="https://domain.com/any.png" imgService="w=100">
 *
 * __Example :__
 *   <img src="https://domain.com/any.png" srcset="https://domain.com/any.png?w=100&dpr=2 2x ..."></div>
 *
 */
@Directive({
    selector: '[imgService]'
})
export class ImgServiceDirective implements AfterViewInit, OnChanges {
    @Input('imgService') params: string;
    @Input() imgServiceBinding: string;

    defaultParams = 'auto=format,compress';

    constructor(
        private elementRef: ElementRef
    ) {
    }

    ngAfterViewInit(): void {
        this.applyChanges(this.elementRef.nativeElement.src);
    }

    protected applyChanges(src: string): void {
        if (src && src.substr(-1) !== '/') {
            const params = this.params ? `?${this.params}&` : '?';
            const srcParams = `${src}${params}${this.defaultParams}`;
            this.elementRef.nativeElement.src = `${srcParams}`;
            this.elementRef.nativeElement.srcset = `${srcParams}&dpr=1 1x, ${srcParams}&dpr=2 2x, ${srcParams}&dpr=3 3x`;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.applyChanges(this.imgServiceBinding);
    }
}

